import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './components/footer';
import viewarrow from './assets/view-app-arrow.svg';
import viewarrowh from './assets/view-app-arrow-black.svg';
import HoverImage from "./components/hover-image";
import BannerSection from './components/banner';
import './deep-dives.css'
import PageTitle from "./components/page-title";
import HeaderBlack from "./components/header-black";


class DeepDive extends React.Component {
    render() {
        return (
            <div className='dd'>
                <div className='flex-column deep-dive-content'>
                    <a href={this.props.deep_dive.route} target='_blank' rel='noreferrer' className='project-name t5 mb-2 mt-2'>{this.props.deep_dive.title}</a>

                    <div className='project-descriere b2'>{this.props.deep_dive.description}</div>

                    <Link className='project-link pointer' to={this.props.deep_dive.route}>
                        <HoverImage imageA={viewarrow} imageB={viewarrowh} className='mr-1' />
                        <div className='link-text b2-m'>Read more</div>
                    </Link>
                </div>
            </div>
        )
    }
}


class DeepDives extends React.Component {
    
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    render() {

        const deepDives = [
            {
                title: 'Debugging a delete error for AWS Cloud9 environment',
                description: "This article provides a comprehensive guide to debugging common deletion errors, helping you identify the root cause and successfully remove your Cloud9 development workspace.",
                route: '/cloud'
            },
            {
                title: 'Moving a self-hosted React website to AWS Amplify',
                description: 'This article gives extensive explanations on the process of how to move a front-end running a React project, served by Nginx from a self managed virtual machine hosted on Vultr to Amazon Web Services, as an Amplify application.',
                route: '/dp-dv-react-to-aws'
            },
            {
                title: 'GoLang Web app on AWS (Part 1) - ECR and Lambda',
                description: "This is the first in a three-part series documenting the development of a web application. We'll cover the challenges and solutions encountered while building a React frontend, a Go Lambda backend, and a DynamoDB database. Part 1 focuses on setting up the Lambda function code using a Docker image.",
                route: '/dp-golang-webapp-ecr'
            },
            {
                title: 'GoLang Web app on AWS (Part 2) - Front-end and CORS errors',
                description: 'This is the second part of our series, focusing on establishing a basic React frontend setup and resolving CORS errors.',
                route: '/dp-golang-webapp-cors'
            },
            {
                title: 'GoLang Web app on AWS (Part 3) - DynamoDB',
                description: "This article details how to manage basic database operations on an AWS DynamoDB database. You'll learn to perform these operations directly from a Lambda function running within a custom Go language Docker container. We'll cover everything from setup to encountered issue.",
                route: '/dp-golang-webapp-dynamodb'
            },
            {
                title: 'GoLang Web app on AWS (Part 4) - Architecture',
                description: "This article shifts focus to the back-end architecture, explaining the design choices behind our implementation. We'll present a practical example of a Clean Layered Architecture and demonstrate its application with two simple Use Cases.",
                route: '/dp-golang-webapp-architecture'
            },
        ];

        return (
            <div id='deep-dives' className='section-background-2'>
                <HeaderBlack />
                
                <PageTitle title={'Deep Dives'}
                           subtitle={'Explore our in-depth articles on complex technical issues. Discover expert solutions and insights from our development team, sharing their knowledge and experience to help you navigate intricate challenges and optimize your technical understanding.'}
                           className="black-background white-color-txt"
                />


                <div className="dd-container page-padding" >
                    <div className='black-band' />
                    { deepDives.map( (dp, index) => <DeepDive key={index} deep_dive={dp} /> )}
                </div>
                
                <div className='space-80'/>
                
                <BannerSection />

                <Footer />
            </div>
        )
    }
}

export default DeepDives;